/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateless
 */
import React, { PropTypes } from 'react';
import Form from 'components/Form';
import locale from './locale';
import './Modal.scss';

class ModalContent extends React.Component {
  constructor(props){
    super(props)

  }

  render() {
    const {onChange, clockData} = this.props;

    const schema = [
      {
        name: 'operation_type',
        label: __('Options', locale),
        type: 'radio',
        options: [{"label": __('Clock In', locale), "value": 1}, {"label": __('Clock Out', locale), "value": 2}],
        required: true,
      },
      {
        name: 'punched_at',
        label: __('Date and Time', locale),
        type: 'dateTime',
        required: true,
      },
      {
        name: 'note',
        label: __('Notes', locale),
        type: 'textarea',
        required: false,
      },
    ];

    return (
      <div className='clockInOut-modal-content'>
        <Form
          onChange={onChange}
          schema={schema}
          formData={clockData}
          formStyle='outline'
          getValidationRef={this.props.getValidationRef}
        />
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/ClockInOut/ModalContent.js